import { render } from "./ItOpsBrowserLab.vue?vue&type=template&id=781c5e7a"
import script from "./ItOpsBrowserLab.vue?vue&type=script&lang=js"
export * from "./ItOpsBrowserLab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__